import ApiConfig from "../config/ApiConfig";

let cachedStatesByAbbr = null;
let cachedStatesByFips = null;

// Prefetch and cache state data
const prefetchStateData = (retried = false) => {
  const stateUrl = new URL(
    ApiConfig.protocol +
      ApiConfig.apiUri +
      ApiConfig.irqInfoEndpoint +
      "/states"
  );

  fetch(stateUrl)
    .then((response) => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    })
    .then((data) => {
      // Cache by state abbreviation
      cachedStatesByAbbr = data.reduce((acc, item) => {
        acc[item.stateAbbr] = item.supported;
        return acc;
      }, {});

      // Cache by FIPS code
      cachedStatesByFips = data.reduce((acc, item) => {
        acc[item.fipsStateCode] = item.supported;
        return acc;
      }, {});
    })
    .catch((error) => {
      console.error("Error fetching state data:", error);
      if (!retried) {
        console.log("Retrying states fetch in 2s...");
        setTimeout(() => prefetchStateData(true), 2000);
      }
    });
};

// Run prefetching logic on app initialization
prefetchStateData();

function eligibleStateCheck(state, stateFips) {
  if (!cachedStatesByAbbr || !cachedStatesByFips) {
    console.warn("State data is not ready yet.");
    return false; // Default to unsupported if data is not ready
  }

  // Prioritize FIPS code lookup
  if (stateFips) {
    const stateFipsNum = parseInt(stateFips, 10);
    if (cachedStatesByFips.hasOwnProperty(stateFipsNum)) {
      return !!cachedStatesByFips[stateFipsNum];
    }
  }

  // Fallback to state abbreviation lookup
  if (state) {
    return !!cachedStatesByAbbr[state];
  }

  return false;
}

export default eligibleStateCheck;
